<template>
    <div class="ConceptModal">
        <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" :id="'Concept'+product">
            <div class="modal-dialog">
                <div class="modal-content m-0 p-0 card justify-content-between">
                    <div class="modal-header" dir="rtl">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
                        <span>بسته بندی مورد نظر خود را انتخاب کنید</span>
                    </div>
                    <div class="products" v-if="objects">
                        <div class="product" :class="['product-concept' + product, index == 0 ? 'active' : '']" v-for="(c,index) in objects" :key="(c,index)">
                            <div class="thumbnail" v-if="!c.video || !c.videoCover">
                              <img v-lazy="$MEDIA + c.image" />
                            </div>
                            <div class="thumbnail" v-if="c.video && c.videoCover">
                              <video height="450" :poster="$MEDIA + c.videoCover" controls muted playsinline autoplay loop>
                                <source :src="$MEDIA + c.video" type="video/mp4">
                              </video>
                            </div>
                            <h1 class="title">{{ c.name }}</h1>
                            <p dir="rtl" v-if="c.price > 0">{{parseInt(c.price).toLocaleString('fa')}} تومان</p>
                            <p dir="rtl" v-if="c.price <= 0">رایگان</p>
                            <p class="description">{{ c.description }}</p>
                            <a class="btn btn-secondary pointer w-50 mt-4" data-bs-dismiss="modal" aria-label="Close" @click="select(product,c)" v-if="selectItem">انتخاب</a>
                        </div>
                    </div>
                    <div class="footer" v-if="objects.length > 1">
                      <a class="btn pointer" @click="prev()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                      <a class="btn pointer" @click="next()"><i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                    </div>
                    <div v-if="objects.length <= 1"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ConceptModal',
  props: {
    objects: null,
    product: null,
    selectItem: null
  },
  methods: {
    prev: function () {
      const productItems = document.querySelectorAll('.product-concept' + this.product)
      let nextItem, productCurrentItem
      for (let i = 0; i < productItems.length; i++) {
        if (productItems[i].classList.contains('active')) {
          nextItem = productItems[i - 1]
          if (!nextItem) {
            nextItem = productItems[productItems.length - 1]
          }
          productCurrentItem = productItems[i]
        }
      }
      nextItem.classList.add('active')
      productCurrentItem.classList.remove('active')
    },
    next: function () {
      const productItems = document.querySelectorAll('.product-concept' + this.product)
      let nextItem, productCurrentItem
      for (let i = 0; i < productItems.length; i++) {
        if (productItems[i].classList.contains('active')) {
          nextItem = productItems[i + 1]
          if (!nextItem) {
            nextItem = productItems[0]
          }
          productCurrentItem = productItems[i]
        }
      }
      nextItem.classList.add('active')
      productCurrentItem.classList.remove('active')
    },
    select: function (product, c) {
      let concept = JSON.parse(localStorage.getItem('concept')) || []
      concept = concept.filter(item => item.product !== product)
      concept.push({ product: product, concept: c })
      localStorage.setItem('concept', JSON.stringify(concept))
      this.emitter.emit('setConcept')
    }
  }
}
</script>
<style scoped>
.product{
  width: -webkit-fill-available;
}

.btn {
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}

.card {
  background: #FFFFFF;
  max-width: 500px;
  margin: 100px auto;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  box-sizing: border-box;
  padding: 48px;
  text-align: center;
}

.products {
  height: 75dvh;
  position: relative;
  overflow: scroll;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}

.product {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}
.product.active {
  opacity: 1;
  visibility: visible;
}

.thumbnail {
  margin: 0 0 48px;
}

.title {
  margin: 0 0 12px;
  color: #D18B49;
  font-size: 24px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}

.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin: 10px;
}

[ripple] {
  z-index: 1;
  position: relative;
  overflow: hidden;
}
[ripple] .ripple {
  position: absolute;
  background: #FFFFFF;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  -webkit-transform: scale(0);
          transform: scale(0);
  -webkit-animation: ripple 2s;
          animation: ripple 2s;
}

@-webkit-keyframes ripple {
  0% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 0.2;
  }
  100% {
    -webkit-transform: scale(20);
            transform: scale(20);
    opacity: 0;
  }
}

@keyframes ripple {
  0% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 0.2;
  }
  100% {
    -webkit-transform: scale(20);
            transform: scale(20);
    opacity: 0;
  }
}
img{
  width: 80%;
}
.modal-content{
  height: 94dvh;
}
</style>
